import {Swiper, SwiperSlide, useSwiper} from "swiper/react";
import {Mousewheel, Navigation} from "swiper/modules";
import "swiper/swiper-bundle.css";
import React from "react";
import { useTranslation } from "react-i18next";

const Slider = () => {
    const { t } = useTranslation();

    return (
        <div className="slider-placement relative">
            <div className="w-full flex flex-col items-center">
                <div className="max-container w-full">
                    <h2
                        className="text-[24px] md:text-[70px] font-bold mb-4 md:mb-12 pl-2">{t('implementationTrack')}</h2>
                </div>
                <Swiper
                    spaceBetween={50}
                    slidesPerView={5}
                    loop={true}
                    navigation={{
                        prevEl: ".swiper-button-prev2",
                        nextEl: ".swiper-button-next2",
                    }}
                    mousewheel={false}
                    breakpoints={{
                        200: {
                            slidesPerView: 1,
                        },
                        460: {
                            slidesPerView: 1.2,
                        },
                        500: {
                            slidesPerView: 1.4,
                        },
                        700: {
                            slidesPerView: 2,
                        },
                        800: {
                            slidesPerView: 2.3,
                        },
                        900: {
                            slidesPerView: 2.5,
                        },
                        1050: {
                            slidesPerView: 3,
                        },
                        1400: {
                            slidesPerView: 4,
                        },
                        1800: {
                            slidesPerView: 5,
                        }
                    }}
                    modules={[Navigation, Mousewheel]}
                    className="slider absolute w-full max-w-[1920px]"
                >

                    <SwiperSlide>
                        <div className="slide-content">
                            <div className="slide-white-text text-xl pt-4">
                                <p style={{fontSize: "18px"}}><span className="number-white-bg">01</span>{t('slider.01')}</p>
                            </div>
                            <img src="/img/front-view-lawyer-working-with-documents.png" alt="slide 1"
                                 className="w-full"/>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="slide-content">
                            <div className="slide-black-text text-xl pt-4">
                                <p style={{fontSize: "18px"}}><span className="number-black-bg">02</span>{t('slider.02')}</p>
                            </div>
                            <img src="/img/adult-woman-presenting-business-plan.png" alt="slide 2" className="w-full"/>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="slide-content">
                            <div className="slide-white-text text-xl pt-4">
                                <p style={{fontSize: "16px"}}><span className="number-white-bg">03</span>{t('slider.03')}</p>
                            </div>
                            <img src="/img/female-web-designer-with-papers-notes-office_2.png" alt="slide 3"
                                 className="w-full"/>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="slide-content">
                            <div className="slide-black-text text-xl pt-4">
                                <p style={{fontSize: "18px"}}><span className="number-black-bg">04</span>{t('slider.04')}</p>
                            </div>
                            <img src="/img/medium-shot-woman-sitting-desk.png" alt="slide 4" className="w-full"/>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="slide-content">
                            <div className="slide-white-text text-xl pt-4">
                                <p style={{fontSize: "18px"}}><span className="number-white-bg">05</span>{t('slider.05')}</p>
                            </div>
                            <img src="/img/industrial-designers-working-office-medium-shot.png" alt="slide 1"
                                 className="w-full"/>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="slide-content">
                            <div className="slide-white-text text-xl pt-4">
                                <p style={{fontSize: "18px"}}><span className="number-white-bg">01</span>{t('slider.01')}</p>
                            </div>
                            <img src="/img/front-view-lawyer-working-with-documents.png" alt="slide 1"
                                 className="w-full"/>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="slide-content">
                            <div className="slide-black-text text-xl pt-4">
                                <p style={{fontSize: "18px"}}><span className="number-black-bg">02</span>{t('slider.02')}</p>
                            </div>
                            <img src="/img/adult-woman-presenting-business-plan.png" alt="slide 2" className="w-full"/>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="slide-content">
                            <div className="slide-white-text text-xl pt-4">
                                <p style={{fontSize: "16px"}}><span className="number-white-bg">03</span>{t('slider.03')}</p>
                            </div>
                            <img src="/img/female-web-designer-with-papers-notes-office_2.png" alt="slide 3"
                                 className="w-full"/>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="slide-content">
                            <div className="slide-black-text text-xl pt-4">
                                <p style={{fontSize: "18px"}}><span className="number-black-bg">04</span>{t('slider.04')}</p>
                            </div>
                            <img src="/img/medium-shot-woman-sitting-desk.png" alt="slide 4" className="w-full"/>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="slide-content">
                            <div className="slide-white-text text-xl pt-4">
                                <p style={{fontSize: "18px"}}><span className="number-white-bg">05</span>{t('slider.05')}</p>
                            </div>
                            <img src="/img/industrial-designers-working-office-medium-shot.png" alt="slide 1"
                                 className="w-full"/>
                        </div>
                    </SwiperSlide>
                </Swiper>
                <div className="navigation-buttons relative -top-24 max-w-[1920px] w-[60vw] z-[40]">
                    <button className="nav-button swiper-button-prev2">
                        <img src="/img/leftArrow.png" alt="Prev" style={{height: "auto", width: "14px"}}/>
                    </button>
                    <button className="nav-button swiper-button-next2">
                        <img src="/img/rightArrow.png" alt="Next" style={{height: "auto", width: "14px"}}/>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Slider;
